import { TranslationKey } from '@hermes/translations'

export const formValidateEmail = (email: string): boolean => {
  if (!email) return false
  if (!/\S+@\S+\.[A-Za-z]{2,}/.test(email)) return false
  if (email.endsWith(' ')) return false
  return true
}

export const formValidatePassword = (password: string): TranslationKey | void => {
  if (!password) return 'password_required'
  if (password.length < 8) return 'password_length'
  if (!/\d/.test(password)) return 'password_numeric'
  if (password.endsWith(' ')) return 'no_trailing_blankspace'
}
